import React from 'react'

const ProgramContext = React.createContext({
    programs: [],
    setProgram: () => {}
})
export const ProgramProvider = ProgramContext.Provider
export default ProgramContext